import api from '../requests';


export async function getNotificationStatus() {
    const response = await api.request({
        method: 'get',
        url: `/internal/risk/notification/status`
    });
    return response.data;
}

export async function updateNotificationStatus(status) {
    const pauseNotification = !status;
    const response = await api.request({
        method: 'post',
        url: `/internal/risk/notification/status?pauseNotification=${pauseNotification}`
    });
    return response.data;
}

export async function acknowledgeOrfAlerts(data) {
    const response = await api.request({
        method: 'post',
        data,
        url: `/internal/risk/trading/orf/user-acknowledge`
    });
    return response.data;
}

export async function acknowledgeEcnAlerts(data) {
    const response = await api.request({
        method: 'post',
        data,
        url: `/internal/risk/trading/ecn/user-acknowledge`
    });
    return response.data;
}

export async function acknowledgeIdqsAlerts(data) {
    const response = await api.request({
        method: 'post',
        data,
        url: `/internal/risk/trading/idqs/user-acknowledge`
    });
    return response.data;
}

export async function acknowledgeLockCrossAlerts(data) {
    const response = await api.request({
        method: 'post',
        data,
        url: `/internal/risk/trading/lock-cross/user-acknowledge`
    });
    return response.data;
}

export async function acknowledgeL1Alerts(data) {
    const response = await api.request({
        method: 'post',
        data,
        url: `/internal/risk/trading/l1/user-acknowledge`
    });
    return response.data;
}

export async function acknowledgeTrfAlerts(data) {
    const response = await api.request({
        method: 'post',
        data,
        url: `/internal/risk/trading/trf/user-acknowledge`
    });
    return response.data;
}